"use client";

import S from "./index.module.scss";
import { Container } from "@/components/ui/container";
import CustomIcon from "@/components/ui/custom-icon";
import Sidebar from "@/components/entities/header/sidebar";
import { useState } from "react";
import { useMedia } from "@/hooks/system/useMedia";
import Link from "next/link";
import AuthModal from "@/views/auth";
import { useAuth } from "@/hooks/useAuth";
import { useIsScrolled } from "@/hooks/system/useIsScrolled";

const Header = () => {
  const { isMobile, isClient } = useMedia();
  const { isAuthenticated } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [isAuthOpen, setIsAuthOpen] = useState(false);
  const isScrolled = useIsScrolled();

  const toggleMenu = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <div className={S.stickyWrapper} data-menu-open={isOpen}>
      <div className={S.headerWrapper}>
        <header className={S.header} data-scrolled={isScrolled}>
          <Container className={S.container}>
            <button type="button" className={S.menuButton} onClick={toggleMenu} aria-label="Toggle menu">
              <CustomIcon fileName={isOpen ? "icon-close" : "icon-menu"} className={S.menuIcon} />
            </button>
            <Link href="/" className={S.logoIcon}>
              <CustomIcon fileName="icon-logo" />
            </Link>
            {isClient && (
              <div className={S.iconWrapper}>
                {/* {((isMobile && !isOpen) || !isMobile) && <LangSwitcher />} */}
                {(!isMobile || isOpen) &&
                  (isAuthenticated ? (
                    <Link href="/profile" aria-label="Open profile">
                      <CustomIcon fileName="icon-user" className={S.userIcon} />
                    </Link>
                  ) : (
                    <button type="button" onClick={() => setIsAuthOpen(true)} aria-label="Open auth modal">
                      <CustomIcon fileName="icon-user" className={S.userIcon} />
                    </button>
                  ))}
              </div>
            )}
          </Container>
        </header>
        {isOpen && <Sidebar onClose={() => setIsOpen(false)} />}

        <AuthModal onOpenChange={setIsAuthOpen} open={!isAuthenticated && isAuthOpen} />
      </div>
    </div>
  );
};

export default Header;
